import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import {
  standardColours,
  brandColours,
  brandFonts,
  standardTransition,
} from '../styles';
import { Container } from './ui';

const StyledPageSectionLinks = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  background-color: ${({ altTheme }) =>
    altTheme === true
      ? brandColours.denary
      : altTheme === false
      ? brandColours.senary
      : standardColours.white};
  transform: translateY(-100%);
  transition: ${standardTransition('transform')};

  ${({ scrolledPastTriggerElement }) => {
    if (scrolledPastTriggerElement) {
      return css`
        transform: translateY(0);
      `;
    }
  }}
`;

const StyledContainer = styled(Container)`
  padding-right: 0;
`;

const StyledItems = styled.ol`
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 20px 0;
  overflow: auto;
`;

const StyledItem = styled.li`
  margin-left: 15px;

  &:first-child {
    margin-left: 0;
  }
`;

const StyledLink = styled.a`
  ${brandFonts.secondary};
  white-space: nowrap;
  transition: ${standardTransition('color')};

  &:hover {
    color: ${brandColours.quinary};
  }
`;

const PageSectionLinks = ({ items, trigger, altTheme }) => {
  const [scrolledPastTriggerElement, setScrolledPastTriggerElement] =
    useState();

  useEffect(() => {
    const triggerElement = document.getElementById(trigger);

    const checkTriggerElementPosition = () => {
      const triggerElementPosition = triggerElement.getBoundingClientRect();

      setScrolledPastTriggerElement(triggerElementPosition.bottom + 60 < 0);
    };

    window.addEventListener('scroll', checkTriggerElementPosition);

    return () => {
      window.removeEventListener('scroll', checkTriggerElementPosition);
    };
  }, []);

  return (
    <StyledPageSectionLinks
      altTheme={altTheme}
      scrolledPastTriggerElement={scrolledPastTriggerElement}
    >
      <StyledContainer>
        <StyledItems>
          {items.map(({ id, text }) => (
            <StyledItem key={id}>
              <StyledLink href={`#${id}`}>{text}</StyledLink>
            </StyledItem>
          ))}
        </StyledItems>
      </StyledContainer>
    </StyledPageSectionLinks>
  );
};

export default PageSectionLinks;
